export default __webpack_public_path__ + "static/media/welcome-bg13.d69a1b40.png";